export default __webpack_public_path__ + "static/media/comprehension_standard.c67f2954.svg";